import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 260px;
  min-width: 240px;
  border-right: 1px solid ${({ theme }) => theme.primary.main};
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 240px;
    min-width: 220px;
  }
`
